<template src="./userActivity.html"></template>

<script>
import {
  get_userList,
  save_userData,
  delete_user,
  get_graficoAccessi,
  get_log_operazioni
} from "@/api/api.admin.js";
import AdminUtenti from "@/components/dialog/AdminUtenti";
import Chart from "@/components/statistiche/chart/LineChart.js";

export default {
  components: {
    AdminUtenti,
    Chart,
  },

  data: () => ({
    dati: [],

    headers: [
      { align: "left", value: "" },
      { text: "Utente", align: "left", value: "Utente" },
      { text: "Tipologia", align: "left", value: "Tipologia" },
      {
        text: "Data registrazione",
        align: "left",
        value: "DataRegistrazione_ISO",
      },
      {
        text: "Ultimo accesso",
        align: "left",
        value: "DataUltimaAttivita_ISO",
      },
      { align: "left", value: "" },
    ],

    search: "",
    pagination: {
      rowsPerPage: 500,
    },
    page: 1,
    pageCount: 0,
    itemsPerPage: 9999,

    alertElaborazione: "",

    dialog: false,
    editedItem: {},
    editedItem_empty: {
      IdUtente: 0,
      Utente: "",
      Password: "",
      Tipologia: "",
      Codice: "",
      EMail: "",
      AccountAttivo: false,
    },
    contUtenti: 0,

    meseSel: 0,
    tabs: 0,
    attesa: false,
    datiAccessi: [],

    chartData: {
      labels: [],
      datasets: [],
    },

    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      plugins: {
        datalabels: {
          color: "#000",
          font: { size: "14" },
          anchor: "end",
          align: "end",
        },
      },

      scales: {
        yAxes: [
          {
            ticks: {
              min: 0,
              beginAtZero: true,
              precision: 0,
              max: 0,
            },
          },
        ],
      },
    },

    dialogStorico: false,
    datiStorico: [],
    headersStorico: [
      { text: "Data", value: "DataOperazione", sortable: true },
      { text: "TipoOperazione", value: "TipoOperazione", sortable: true },
      { text: "Descrizione", value: "Descrizione", sortable: true },
      { text: "VecchioValore", value: "VecchioValore", sortable: true },
      { text: "NuovoValore", value: "NuovoValore", sortable: true },
      { text: "Utente", value: "Utente", sortable: true },
      { text: "TipoUtente", value: "TipoUtente", sortable: true },
    ],
  }),

  methods: {
    async caricaDati() {
      // Reset
      this.dati = [];
      let res = await get_userList("");
      this.dati = res.data;
      this.contUtenti = this.dati.length;
    },

    async editItem(item) {
      let res = await get_userList(item.IdUtente);
      this.editedItem = res.data;
      // Apro la dialog
      this.openDialog();
    },

    async save() {
      this.alertElaborazione = "";

      // Salvo su db
      await save_userData(this.editedItem);
      // Ricarico i dati
      this.caricaDati();
      // Chiudo la dialog
      this.closeDialog();
    },

    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },

    nuovoUtente() {
      // Reset
      //this.editedItem = Object.assign({}, this.editedItem_empty);
      this.editedItem = this.editedItem_empty;
      this.openDialog();
    },

    elimina() {
      // Controllo nuovo
      if (this.editedItem.IdUtente == 0) return;

      this.$root
        .$confirm("Elimina", "Vuoi eliminare il dato ?")
        .then((confirm) => {
          if (!confirm) return;

          delete_user(this.editedItem.IdUtente)
            .then((res) => {
              // Ricarico i dati
              this.caricaDati();
            })
            .catch((err) => {
              //alert(err);

              console.log("useractivity.vue " + err);
            });

          this.closeDialog();
        });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    async caricaGrafico() {
      this.attesa = true;
      let res = await get_graficoAccessi(
        this.getMesi().indexOf(this.meseSel) + 1
      );
      if (res.data == null || res.data.length <= 0) return;
      this.datiAccessi = res.data;

      this.chartData.datasets = [];
      this.chartData.labels = [];
      let valAccessi = [];
      for (let a in this.datiAccessi) {
        this.chartData.labels.push(
          this.$i2kFunctions
            .formatISODate(this.datiAccessi[a].Data)
            .toString()
            .substring(0, 2)
        );
        valAccessi.push(this.datiAccessi[a].Accessi);
      }
      this.chartData.datasets.push({
        label: "Accessi",
        borderColor: "black",
        fill: false,
        data: valAccessi,
      });
      this.options.scales.yAxes[0].ticks.max = this.getMax();
      this.attesa = false;
    },

    getMax() {
      let max = this.datiAccessi[0].Accessi;
      for (let i = 1; i < this.datiAccessi.length; i++) {
        if (this.datiAccessi[i].Accessi > max)
          max = this.datiAccessi[i].Accessi;
      }
      return max + 20;
    },

    getMesi() {
      return this.$i2kFunctions.getMonths();
    },

    mostraLog() {
      this.dialogStorico = true;
      this.caricaStorico();
    },

    chiudiLog() {
      this.dialogStorico = false;
    },

    async caricaStorico() {
      let res = await get_log_operazioni();
      this.datiStorico = res.data;
    }
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);

    this.caricaDati();
    this.meseSel = this.getMesi()[this.$i2kFunctions.getMonth() - 1];
  },
};
</script>
